import './input-with-upload-button.component.scss';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const InputWithUploadButton = props => {
  const {
    id,
    type,
    name,
    value,
    buttonLabel,
    containerClassName,
    inputClassName,
    placeholder,
    autoComplete,
    htmlFor,
    style,
    isInvalid,
    isHide,
    disabled,
    buttonClassName,
    onClick,
    onChange,
    onFocus,
    onBlur,
    buttonOnClick,
    ...other
  } = props;
  const { t } = useTranslation();

  const classNameList = {
    invalid: 'invalid',
    disabled: 'disabled',
  };

  const invalidClassName = !!isInvalid ? classNameList['invalid'] : '';
  const disabeldClassName = !!disabled ? classNameList['disabled'] : '';
  const currentValue = value === null || value === undefined ? '' : value;
  const isButtonLabel = !!buttonLabel ? buttonLabel : t('1b9abf135c'); // Browse

  return (
    <>
      {!isHide && (
        <div
          className={`input-with-upload-button-container input-container ${invalidClassName} ${disabeldClassName} ${containerClassName}`}
          style={style}
        >
          <input
            id={`input-with-upload-area ${id}`}
            type="file"
            accept="image/png,image/jpeg,image/jpg,image/gif,image/bmp,image/tiff,image/webp"
            className={`d-none ${inputClassName}`}
            autoComplete={autoComplete}
            onClick={onClick}
            onChange={onChange}
            {...other}
          />
          <label htmlFor={`input-with-upload-area ${id}`} className="file-label">
            <input
              name={name}
              placeholder={t(placeholder)}
              value={currentValue}
              disabled={disabled}
              onClick={onClick}
              readOnly
            />
            <span className="browse-button">{t(isButtonLabel)}</span>
          </label>
        </div>
      )}
    </>
  );
};

export default memo(InputWithUploadButton);
